// extracted by mini-css-extract-plugin
module.exports = {"appWrapper":"Hero-3D-styles-module--appWrapper--3NSCv","app":"Hero-3D-styles-module--app--_B4a3"};